export default class PostAuctionController {
    constructor() {
        const element = document.querySelector(".js-auction-default");

        if (element) {
            import(
                /* webpackChunkName: "PostAuction" */ "../classes/PostAuction"
            ).then(res => {
                const PostAuction = res.default;
                this.createInstance(PostAuction, element);
            });
        }
    }

    createInstance(PostAuction, element) {
        return new PostAuction(element);
    }
}
